module.exports = __webpack_public_path__ + "static/Gilroy-Extrabold-bc3a01669ab88aa1005c52012e13a5e8.woff";